export enum DocumentFileType {
  File = 'file',
  Html = 'html',
  Link = 'link',
}
